import { ISubtotal } from "../order/types";

export default class BasketItemsSubtotalPrice implements ISubtotal {

  price: string | number;
  checkout: string | number;
  installments?: number;

  constructor(price: string | number, checkout: string | number, installments: number | undefined) {
    this.price = price;
    this.checkout = checkout;
    this.installments = installments;
  }

}
